<tg-col class="property-information-notice">
	<tg-row>
		<tg-col>
			<tg-info-box>
                {{noticeMessage}}
          </tg-info-box>
		</tg-col>
	</tg-row>
</tg-col>
